import OnlyTextContent from "./OnlyTextContent";
import OnlyTextMain from "./OnlyTextMain";
import OnlyTextTitle from "./OnlyTextTitle";
import OnlyTextWrapper from "./OnlyTextWrapper";

export { OnlyTextContent, OnlyTextMain, OnlyTextTitle, OnlyTextWrapper };
